const BASE_URL = "https://projectauthcecilialinus-lonzreseuq-lz.a.run.app";

export const API_URL = (slug) => `${BASE_URL}/${slug}`;

//Loacal host http://localhost:8090